 <!-- ======= Header ======= -->

<header id="header" class="header fixed-top d-flex align-items-center">
  <div class="d-flex align-items-center justify-content-between">
  <a href="index.html" class="logo d-flex align-items-center"> <img src="../../../assets/images/logo.png" alt=""> </a>
  <a href="index.html" class="logo d-flex tar-logo align-items-center">
    <img src="../../../assets/images/trasheed_logo.png" alt="">
    </a>
  <!--<a (click)="toggleSideBar()"><i class="bi bi-list toggle-sidebar-btn"></i></a>--> </div>
  <!-- End Logo -->
  <div *ngIf="isSuspended"><h3 style="color: #e51638">{{'Your account is suspended'| translate}}</h3></div>
  <nav *ngIf="showLoggedActions" class="header-nav ">
    <ul class="d-flex align-items-center">

      <!-- End Profile Nav -->
      
      <li class="sp-logo-header"> <a href="#"> <img src="{{UserNameLogo}}"> </a> </li>
      <li class="nav-item dropdown">
        <!--<a class="nav-link nav-icon" href="#" data-bs-toggle="dropdown"> <i class="bi bi-bell"></i> <span class="badge bg-primary badge-number">4</span> </a>--><!-- End Notification Icon -->
       
        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
          <li class="dropdown-header"> You have 4 new notifications <a href="#"><span class="badge rounded-pill bg-primary p-2 ms-2">View all</span></a> </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li class="notification-item">
            <i class="bi bi-exclamation-circle text-warning"></i>
            <div>
             
              <h4>Lorem Ipsum</h4>
              <p>Quae dolorem earum veritatis oditseno</p>
              <p>30 min. ago</p>
            </div>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li class="notification-item">
            <i class="bi bi-x-circle text-danger"></i>
            <div>
              <h4>Atque rerum nesciunt</h4>
              <p>Quae dolorem earum veritatis oditseno</p>
              <p>1 hr. ago</p>
            </div>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li class="notification-item">
            <i class="bi bi-check-circle text-success"></i>
            <div>
              <h4>Sit rerum fuga</h4>
              <p>Quae dolorem earum veritatis oditseno</p>
              <p>2 hrs. ago</p>
            </div>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li class="notification-item">
            <i class="bi bi-info-circle text-primary"></i>
            <div>
              <h4>Dicta reprehenderit</h4>
              <p>Quae dolorem earum veritatis oditseno</p>
              <p>4 hrs. ago</p>
            </div>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li class="dropdown-footer"> <a href="#">Show all notifications</a> </li>
        </ul>
        <!-- End Notification Dropdown Items -->

      </li>
      <li class="nav-item dropdown pe-3">
        <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
          <div class="profile-icon rounded-circle"> {{FirstLetterOfLoggedUser}} </div>
          <span class="d-none d-md-block dropdown-toggle ps-2">{{LoggedInUserName}} </span>
        </a><!-- End Profile Iamge Icon -->

        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li class="dropdown-header">
            <h6>{{LoggedInUserName}}</h6>
            <span> {{this.userInfo.role}} </span>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li> <a class="dropdown-item d-flex align-items-center"  (click)="viewProfile()"> <i class="bi bi-person"></i> <span>Profile</span> </a> </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li> <a class="dropdown-item d-flex align-items-center"  (click)="changePassword()" *ngIf="!isSuspended"> <i class="bi bi-unlock"></i> <span>Change Password</span> </a> </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li> <a class="dropdown-item d-flex align-items-center" (click)="logout()"> <i class="bi bi-box-arrow-right"></i> <span>{{'signout'| translate}}</span> </a> </li>
        </ul>
        <!-- End Profile Dropdown Items -->
      </li>
    </ul>
  </nav>
  <!-- End Icons Navigation -->

</header>
